import { Component, OnInit ,ViewChild ,SimpleChanges, Output, EventEmitter, Input } from '@angular/core';
import { MatTableDataSource,MatSort, MatPaginator } from '@angular/material';
import { ReportService } from 'src/app/services/report.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2'
export interface demo {}

@Component({
  selector: 'smart-report-pod-plot',
  templateUrl: './report-pod-plot.component.html',
  styleUrls: ['./report-pod-plot.component.scss','../report.component.scss']
})
export class ReportPodPlotComponent implements OnInit {
  tableColumns: string[] = ['farm_name','plot_name','month', 'year','point_name','sum_good_data', 'sum_fallen_data',
  'sum_rotten_data','sum_breeding_issue_data','sum_other_problem_data', 'sum_all_data', 'group_type',  ];
  dataSource: MatTableDataSource < demo >
  data_table:any=[]
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Input() filter_date : any;
  @Input() farmId :string;
  @Input() zoneId :string;
  @Input() plotId :string;
  @Input() poleName :any;
  @Input() child_org:string;
  @Output() output = new EventEmitter<string>();
  constructor(
    private reportservice : ReportService,
    private spinner: NgxSpinnerService
  ) {
    
   }
  ngOnInit(): void {

  }
  ngOnChanges(changes: SimpleChanges) {
    if(changes.farmId || changes.plotId || changes.zoneId || changes.filter_date || changes.poleName){
      if((changes.farmId&& changes.farmId.firstChange == false )||
      (changes.zoneId&& changes.zoneId.firstChange == false )||
      (changes.plotId&& changes.plotId.firstChange == false )||
      (changes.poleName && changes.poleName.firstChange == false )||
      (changes.filter_date&& changes.filter_date.firstChange == false )
      ){
        this.spinner.show()
        this.getReportPodPlot()
      }
    }
  }
  getReportPodPlot(){
    let body ={
      farm_id : this.farmId,
      child_org_id:this.child_org,
      plot_id: this.plotId,
      zone_id:this.zoneId,
      point_name: this.poleName,
      year_month : this.filter_date,
      group_type : "Pod"
    }
    this.reportservice.getReportPodPlot(body).subscribe(
      async result => {
        if (result.code == 200) {
          this.data_table=result.data.table
          this.dataSource = new MatTableDataSource(this.data_table);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.dataSource.sortingDataAccessor = (item:any, property) => {
            switch (property) {
              case 'month': return parseInt(this.format_month_number(item.month)) ;
              default: return item[property];
            }
          };
          this.output.emit(result.data.table)
          this.spinner.hide()
        }else{
          this.spinner.hide()
          Swal.fire({
            icon: 'error',
            title: 'เกิดข้อผิดพลาดในการเรียกข้อมูล',
            showConfirmButton: false,
            timer: 3000
          })
          this.data_table =[]
          this.dataSource = new MatTableDataSource(this.data_table);
          this.dataSource.paginator = this.paginator;
        }
      }
    )
  }
  format_month_number(data){
    switch (data) {
      case 'January':
        data = '0'
        break;
      case 'February':
        data = '1'
        break;
      case 'March':
        data = '2'
        break;
      case 'April':
        data = '3'
        break;
      case 'May':
        data = '4'
        break;
      case 'June':
        data = '5'
        break;
      case 'July':
        data = '6'
        break;
      case 'August':
        data = '7'
        break;
      case 'September':
        data = '8'
        break;
      case 'October':
        data = '9'
        break;
      case 'November':
        data = '10'
        break;
      case 'December':
        data = '11'
        break;
    }

  return data
  }

}
